import {
  SvgIcon as MuiSvgIcon,
  SvgIconProps as MuiSvgIconProps,
} from "@mui/material";

export const ArrowLeftIcon = (props: MuiSvgIconProps) => (
  <MuiSvgIcon {...props} data-testid="arrow-left-icon">
    <path
      d="M9.95192 17.6534L4.2981 11.9995L9.95192 6.3457L11.0057 7.4303L7.1865 11.2496H19.7019V12.7495H7.1865L11.0057 16.5688L9.95192 17.6534Z"
      fill="var(--gravx-color-neutral-on-light-grey-8)"
    />
  </MuiSvgIcon>
);
